import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import MUITooltip from '@material-ui/core/Tooltip';

import { Card } from 'core/components/card';
import Checkbox from 'core/components/checkbox';
import { Label } from 'core/components/label';
import resetIcon from 'core/assets/svg/ic-reset.svg';
import useStyles from './task-filters.styles';

const optionShape = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired
  })
);

const TaskFilters = ({ policyTypeOptions, statusOptions, onTogglePolicyType, onToggleStatus, onReset }) => {
  const classes = useStyles();
  const renderGroup = (title, prefix, options, onToggle) => (
    <div className={classes.group}>
      <Label type="infoLabel">{title}</Label>
      <div className={classes.options}>
        {options.map(({ value, label, checked }) => (
          <Checkbox
            key={value}
            id={`${prefix}-${value}`}
            mode="light"
            className={classes.checkbox}
            label={label}
            value={checked}
            onChange={() => onToggle(value)}
          />
        ))}
      </div>
    </div>
  );

  return (
    <Card className={classes.card}>
      <div className={classes.titleRow}>
        <span className={classes.title}>Filter tasks</span>
        <MUITooltip arrow placement="top" title="Reset filter to show all tasks" classes={{ tooltip: classes.tooltip }}>
          <Button disableFocusRipple className={classes.resetButton} onClick={onReset} variant="text" color="secondary">
            <img alt="" className={classes.resetIcon} src={resetIcon} />
            Reset filter
          </Button>
        </MUITooltip>
      </div>
      {/* Design note (#35550): if filtering ever needs 3+ rows of checkbox groups, replace these with a picklist filter. */}
      <div className={classes.groups}>
        {renderGroup('Show tasks with these statuses', 'task-filter-status', statusOptions, onToggleStatus)}
        {renderGroup(
          'Show tasks for these policy type(s)',
          'task-filter-policy-type',
          policyTypeOptions,
          onTogglePolicyType
        )}
      </div>
    </Card>
  );
};

TaskFilters.propTypes = {
  policyTypeOptions: optionShape.isRequired,
  statusOptions: optionShape.isRequired,
  onTogglePolicyType: PropTypes.func.isRequired,
  onToggleStatus: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired
};

export default TaskFilters;
